import { Center, Heading, Stack, Text } from "@chakra-ui/react"
import type { NextPage } from "next"

import Page from "@shared/ui/page"

const Home: NextPage = () => {
  return (
    <Page title={"Welcome to Web-toolkit"} metaDescription={"The Web-toolkit - little tools for developers."}>
      <Stack>
        <Center>
          <Heading as="h2" size="xl" mb={4}>
            SQ-dev
          </Heading>
        </Center>
        <Center>
          <Text>Some tools that might be useful to a developer.</Text>
        </Center>
      </Stack>
    </Page>
  )
}

export default Home
